import React from "react";
import { useNavigate, Link } from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import mainBg from "../../assets/img/bg-company-03.jpg";
import certi01 from "../../assets/img/certification-01.jpg";
import certi02 from "../../assets/img/certification-02.jpg";
import certi03 from "../../assets/img/certification-03.jpg";
import certi04 from "../../assets/img/certification-04.jpg";
import certi05 from "../../assets/img/certification-05.jpg";
import certi06 from "../../assets/img/certification-06.jpg";
import certi07 from "../../assets/img/certification-07.jpg";
import certi08 from "../../assets/img/certification-08.jpg";
import certi09 from "../../assets/img/certification-09.jpg";
import certi10 from "../../assets/img/certification-10.jpg";
import certi11 from "../../assets/img/certification-11.jpg";

function CoreCompetence() {
	// 일반 또는 관리자 header 설정
	const { argInfo } = useContext(ArgContext);
	const isAdmin = argInfo?.role === 'admin';

    // 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

    return (<>
	<main className="page-wrapper">
			{isAdmin ? <AdminHeader /> : <Header />}
			{/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
						<h2>인증 및 협약</h2>
						<p>위피아는 선도적인 기술력으로 여러 기관의 인증 및 협약을 진행하였습니다.</p>
					</div>
					<SubMenu />
			</section>

			<section className="container-auto sec-my">
				<ul className="coreCompetence-list">
					<li>
						<img src={certi01} alt="정보통신공사업 등록" />
						<p>정보통신공사업 등록</p>
					</li>
					<li>
						<img src={certi02} alt="벤처기업 확인서" />
						<p>벤처기업 확인서</p>
					</li>
					<li>
						<img src={certi03} alt="프로그램 등록" />
						<p>프로그램 등록</p>
					</li>
					<li>
						<img src={certi04} alt="위치기반사업자" />
						<p>위치기반사업자</p>
					</li>
					<li>
						<img src={certi05} alt="모바일 광고서비스 특허등록" />
						<p>모바일 광고서비스 특허등록</p>
					</li>
					<li>
						<img src={certi06} alt="스마트 가로등 및 스마트 가로등을 이용한 범죄예방 시스템" />
						<p>스마트 가로등 및 스마트 가로등을 이용한 범죄예방 시스템</p>
					</li>
					<li>
						<img src={certi07} alt="자연어를 이용한 로봇제어시스템 특허권" />
						<p>자연어를 이용한 로봇제어시스템 특허권</p>
					</li>
					<li>
						<img src={certi08} alt="현대오토에버 동반성장 협약사" />
						<p>현대오토에버 동반성장 협약사</p>
					</li>
					<li>
						<img src={certi09} alt="기업부설연구소 인증서" />
						<p>기업부설연구소 인증서</p>
					</li>
					<li>
						<img src={certi10} alt="가족친화인증서" />
						<p>가족친화인증서</p>
					</li>
					<li>
						<img src={certi11} alt="ESG 우수 중소기업 확인서" />
						<p>ESG 우수 중소기업 확인서</p>
					</li>
				</ul>
			</section>




		</main>
	<Footer />
        </>
    )
}

export default CoreCompetence;